/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {PrettyPrintReferencePipe} from './pretty-print-reference/pretty-print-reference.pipe';
import {UndefinedValuePipe} from './undefined-value/undefined-value.pipe';
import {UserDisplayPipe} from './user-display/user-display.pipe';
import {FormatPartnerDisplayStringPipe} from './format-partner-display-string/format-partner-display-string.pipe';
import {PrettyPrintDescriptionPipe} from './pretty-print-description/pretty-print-description.pipe';
import {PrettyPrintMaterialNumberPipe} from './pretty-print-material-number/pretty-print-material-number.pipe';
import {AnyKeyValuePipe} from './any-key-value/any-key-value.pipe';
import {UtcAsLocalPipe} from './utc-as-local/utc-as-local.pipe';
import {PrettyPrintUpdatedByPipe} from './pretty-print-updated-by/pretty-print-updated-by.pipe';
import {PrettyPrintPercentagePipe} from './pretty-print-percentage/pretty-print-percentage.pipe';
import {JoinArrayStringsPipe} from './join-array-strings/join-array-strings.pipe';

@NgModule({
    declarations: [
        PrettyPrintReferencePipe,
        PrettyPrintPercentagePipe,
        UndefinedValuePipe, UserDisplayPipe,
        FormatPartnerDisplayStringPipe,
        PrettyPrintDescriptionPipe,
        PrettyPrintMaterialNumberPipe,
        AnyKeyValuePipe,
        UtcAsLocalPipe,
        PrettyPrintUpdatedByPipe,
        JoinArrayStringsPipe
    ],
    imports: [],
    exports: [
        PrettyPrintReferencePipe,
        PrettyPrintPercentagePipe,
        UndefinedValuePipe,
        UserDisplayPipe,
        FormatPartnerDisplayStringPipe,
        PrettyPrintDescriptionPipe,
        PrettyPrintMaterialNumberPipe,
        AnyKeyValuePipe,
        UtcAsLocalPipe,
        PrettyPrintUpdatedByPipe,
        JoinArrayStringsPipe
    ]
})
export class PipesModule {
}
